<template>
  <div>
    <v-layout>
      <v-flex :sm5="!full" :sm6="full" :xs5="!full" :xs6="full">
        <v-btn :color="showFilter? 'green' : 'black'" :outline="showFilter ? false : true" @click="filterSwitched">
          Filtry
        </v-btn>
        <v-btn
          fab small
          v-if="showFilter"
          @click="range++"
          >
          <v-icon small>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <div v-if="show">
      <div>
        <slot></slot>
      </div>
      <div :key="i" v-for="i in range">
        <v-layout >
          <v-flex :sm3="!full" :sm6="full" :xs5="!full" :xs6="full">
            <v-select
              @change="changeHandler"
              :items="fields"
              item-text="name"
              item-value="value"
              v-model="choosenFields[i]"
              :label="`${$t('form.inputs.select_field')}`"
            ></v-select>
          </v-flex>

          <v-flex v-if="isRadioField(choosenFields[i])" :sm3="!full" :sm6="full" :xs5="!full" :xs6="full">
            <v-select
                v-model="search[i]"
                :items="getRadioValues(choosenFields[i])"
                item-text="value"
                item-value="key"
                label="Szukaj"
                prepend-icon="search"
                required
                style="margin-left:2rem;"
                @change="changeHandler"
            ></v-select>
          </v-flex>

          <v-flex v-if="isRadioField(choosenFields[i])" :sm3="!full" :sm6="full" :xs5="!full" :xs6="full">
            <v-select
                v-model="search[i]"
                :items="getRadioValues(choosenFields[i])"
                item-text="value"
                item-value="key"
                label="Szukaj"
                prepend-icon="search"
                required
                style="margin-left:2rem;"
                @change="changeHandler"
            ></v-select>
          </v-flex>

          <v-flex v-if="isDateField(choosenFields[i])" :sm3="!full" :sm6="full" :xs5="!full" :xs6="full">
            <v-menu v-model="menuDate" :close-on-content-click="false" :nudge-right="40" full-width lazy
                    min-width="290px"
                    offset-y transition="scale-transition">
              <template v-slot:activator="{ on }">
                <!--                TODO bug-->
                <v-layout>
                  <v-flex lg10 md10 xs12>
                    <v-text-field v-model="search[i]" :label="`${$t('form.search.to')}`" clearable
                                  style="margin-left:2rem;" @click="(e) => !dataAsText ? on.click(e) : null"
                                  @click:clear="changeHandler"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 xs1>
                    <v-checkbox v-model="dataAsText" prepend-icon="edit"></v-checkbox>
                  </v-flex>
                </v-layout>
              </template>
              <v-date-picker v-model="search[i]" @change="changeHandler" @input="menuDate = false"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex v-else :sm3="!full" :sm6="full" :xs5="!full" :xs6="full">
            <v-text-field @change="changeHandler"
              style="margin-left:2rem;"
              v-model="search[i]"
                          :prepend-icon="full ? '' : 'search'"
              label="Szukaj"
              required
            ></v-text-field>
          </v-flex>
          <v-flex :sm1="full" :sm2="!full" :xs1="full" :xs2="!full">
          <v-btn
          v-if="i!=1"
          style="margin-left:2rem;"
            fab small block
            @click="removeFiltr(i)">
            <v-icon small>remove</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import QueryConditionBuilder from '@/plugins/QueryConditionBuilder'
import InputHelper from '@/plugins/InputHelper'
import Settings from "@/plugins/Settings"

export default {
  props: ["full"],
  components: {},
  data() {
    return {
      dataAsText: false,
      QueryConditionBuilder: QueryConditionBuilder,
      search: [],
      showFilter: false,
      range: 1,
      menuDate: false,
      choosenFields: [],
      lastCondition: "{}",
      baseFieldsFilter: [
        {name: "Imie", value: "name"},
        {name: "Nazwisko", value: "surname"}
      ]
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
    fields(){
      let fields =  this.$store.state.forms.schema.fields
          .filter(this.isEditableField)
          .map(field => {
            return {name: field.name, value: field.order}
          })
      return this.baseFieldsFilter.concat(fields)
    },
    show(){
      return this.showFilter
    }
  },
  methods:{
    getField(order) {
      if (!order) {
        return false
      }

      return this.$store.state.forms.schema.fields.find(el => el.order == order)
    },
    getRadioValues(order) {
      let field = this.getField(order)
      return field.values.map(v => ({key: String(v.key), value: v.value}))
    },
    isRadioField(order) {
      let field = this.getField(order)
      return field ? field.type == 'radio' : false
    },
    isDateField(order) {
      let field = this.getField(order)
      return field ? field.type == 'date' : false
    },
    removeFiltr(index){
      this.choosenFields.splice(index,1);
      this.search.splice(index,1)
      this.range--;
      this.$emit('change-condition',this.buildCondition())
    },
    clearURLQueryParams() {
      window.history.pushState({}, document.title, window.location.pathname)
    },
    buildCondition() {
      let queryBuilder = new this.QueryConditionBuilder()
      let field
      this.clearURLQueryParams()
      const searchURL = new URL(window.location)

      this.choosenFields.forEach((paramName, i) => {
        if (!this.search[i]) {
          return
        }

        if (this.QueryConditionBuilder.baseFields().includes(paramName)) {
          queryBuilder.appendBaseFieldCondition(paramName, this.search[i])
          searchURL.searchParams.set(paramName, this.search[i])
        }else {
          field = this.$store.state.forms.schema.fields.find(function (el) {
            return el.order == paramName
          })

          searchURL.searchParams.set(queryBuilder.buildParamName(field), this.search[i])
          queryBuilder.appendCondition(field, this.search[i])
        }
      })

      window.history.pushState({}, '', searchURL)
      return queryBuilder.getConditions()
    },
    changeHandler() {
      let condition = this.buildCondition()
      let conditionLength = Object.keys(condition).length
      let strCondition = JSON.stringify(condition)

      if ((conditionLength > 0 && strCondition != this.lastCondition) ||
      (conditionLength == 0 && strCondition != this.lastCondition) ){

        this.$emit('change-condition', condition)
        this.lastCondition = strCondition
      }
    },
    filterSwitched() {
      this.showFilter = !this.showFilter
      if (!this.showFilter && !Settings.keepFiltersWhenDisabled()) {
        this.$emit('change-condition', {})
        this.clearURLQueryParams()
        this.choosenFields = []
        this.search = []
        this.range = 1
      }
    },
    isEditableField(field) {
      return InputHelper.isEditableField(field)
    },
    applyFilterFromUrl() {
      let queryBuilder = new this.QueryConditionBuilder()
      let i = 1

      for (let paramName in this.$route.query) {
        let order = queryBuilder.extractOrder(paramName)

        if (this.QueryConditionBuilder.baseFields().includes(paramName)) {
          this.choosenFields[i] = (paramName)
        } else if (order && order > 0) {
          this.choosenFields[i] = (order)
        } else {
          return
        }

        this.search[i] = (this.$route.query[paramName])
        i++
      }

      if (this.search.length > 0) {
        this.range = this.search.length
        this.$emit('change-condition', this.buildCondition())
        this.showFilter = true
      }
    }
  },
  created() {
    this.applyFilterFromUrl()
  }
}
</script>

<style>
.filtr-active {
  background-color: #00ab00 !important;
}
</style>
